import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import type { CampaignConfigResponse, CampaignConfigApiError } from './types'
import { getCampaignConfigApi } from './helpers'
import { retryUnlessAccessDenied } from '@/utils/helper.utils'

export function useCampaignConfig() {
  const { brandId } = useParams<{ brandId: string }>()
  const { data, isLoading, error, refetch } = useQuery<
    CampaignConfigResponse,
    CampaignConfigApiError
  >({
    queryKey: ['campaignConfig', brandId],
    queryFn: () => getCampaignConfigApi(brandId as string),
    enabled: !!brandId,
    staleTime: Infinity,
    retry: retryUnlessAccessDenied,
  })

  return {
    channelTypes: data?.channel_types ?? [],
    platforms: data?.platforms ?? [],
    maxLinksPerCampaign: data?.max_links_per_campaign,
    brand: data?.brand,
    isLoading,
    error,
    refetch,
  }
}
